
import "@babel/polyfill";
import { polyfill } from 'es6-promise'; polyfill();
import "isomorphic-fetch";

import SaveForm from '../../vendor/vsf/forms/js/SaveForm';
import DeleteForm from '../../vendor/vsf/forms/js/DeleteForm';
import FormsLists from '../../vendor/vsf/forms/js/FormsLists';
import AjaxAction from '../../vendor/vsf/forms/js/AjaxAction';
import Util from '../../vendor/vsf/forms/js/Util';

import Login from '../../vendor/vsf/advanced-login/js/Login';
import ScreenOnSessionExpired from '../../vendor/vsf/advanced-login/js/ScreenOnSessionExpired';
import RememberPassword from '../../vendor/vsf/advanced-login/js/RememberPassword';
import RememberChangePassword from '../../vendor/vsf/advanced-login/js/RememberChangePassword';

// Asigno al namespace global "window" lo que necesito para que se llame en las páginas de la aplicación
window.SaveForm=SaveForm;
window.DeleteForm=DeleteForm;
window.FormsLists=FormsLists;
window.AjaxAction = AjaxAction;
window.Util = Util;

window.Login = Login;
window.ScreenOnSessionExpired = ScreenOnSessionExpired;
window.RememberPassword = RememberPassword;
window.RememberChangePassword = RememberChangePassword;

//Funciones comunes
window.ajaxAction = new AjaxAction();

$(function() {

    window.ajaxAction.initEvents();

    $(".sidebar .nav-dropdown-toggle").click(function(){
        $(this).closest('.nav-dropdown').toggleClass('open');
        return false;
    });

    //Desglosa el menu del link activo
    $(".sidebar .nav-link.active").parents('.nav-dropdown').find('> .nav-dropdown-toggle').click();

    //select2
    $("select:not(.no-select2)").select2({
        theme: "bootstrap",
        minimumResultsForSearch: 10
    });

    //Para hacer que el clear no despliegue las opciones
    $("select").on("select2:clear", function (evt) {
        $(this).on("select2:opening.cancelOpen", function (evt) {
            evt.preventDefault();

            $(this).off("select2:opening.cancelOpen");
        });
    });

    //scroll to top
    $(window).scroll(function () {
        if ($(this).scrollTop() > 400) {
            $('#back-to-top').addClass('show');
        } else {
            $('#back-to-top').removeClass('show');
        }
    });
    $('#back-to-top').on('click', function() {
        $('html, body').animate({scrollTop: 0}, 300);
        return false;
    });

    //scroll to bottom
    $(window).scroll(function () {
        if ($(this).scrollTop() < ($(document).height()-$(window).height())-100) {
            $('#back-to-bottom').addClass('show');
        } else {
            $('#back-to-bottom').removeClass('show');
        }
    });
    $('#back-to-bottom').on('click', function() {
        $('html, body').animate({scrollTop: $(document).height()-$(window).height()}, 300);
        return false;
    });

    //search
    let $listForm = $("#listForm");
    $listForm.find("input[name^='filter'],select[name^='filter']").change(function(){
        $listForm.find(".filter .btn-refresh").hide();
        $listForm.find(".filter .btn-search").show();
    });

    $listForm.find(".filter .btn-refresh").click(function(){
        //$listForm.find(".search .btn-refresh").trigger("click");

        $listForm.find("input[name='q']").val("");
        $listForm.find("input[name='rowsPerPage']").val("");
        $listForm.find("input[name='orderField']").val("");
        $listForm.find("input[name='orderMode']").val("");
        $listForm.find("input[name^='filter']").val("");
        $listForm.find("select[name^='filter']").each(function (index) {
            $(this).get(0).selectedIndex = 0;
        });
        $listForm.find("input[name='currentPage']").val(1);
        $listForm.submit();
    });

    $(".search .btn-refresh").remove();

    //Tooltip
    $('[data-toggle="tooltip"]').tooltip();

    //Sidebar
    $(".btn-sidebar,.sidebar-overlay").click(function() {
        $("body").toggleClass("sidebar-hidden");
    });

    //Buscador
    function cleanText(text) {
        return text.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().trim();
    }

    function search(){
        let q = cleanText($(".form-group-search input").val());

        var result = $("#result");
        //result.text("Mostrando todas las variantes");

        if(q !== undefined && q != ""){
            var resultFind = 0;


            $(".table-inc-pedido-detalle tbody tr").each(function() {
                var $this = $(this);

                //Palabra completa
                /*var subresult = false;
                subresult = subresult || cleanText($this.attr("data-modelo")).indexOf(q) >= 0;
                subresult = subresult || cleanText($this.attr("data-nombre")).indexOf(q) >= 0;
                subresult = subresult || cleanText($this.attr("data-tejido")).indexOf(q) >= 0;
                subresult = subresult || cleanText($this.attr("data-color")).indexOf(q) >= 0;
                subresult = subresult || cleanText($this.attr("data-variante1")).indexOf(q) >= 0;
                subresult = subresult || cleanText($this.attr("data-variante2")).indexOf(q) >= 0;
                subresult = subresult || cleanText($this.attr("data-variante3")).indexOf(q) >= 0;

                if(subresult){
                    $this.show();
                } else {
                    $this.hide();
                }*/

                //Procesamos cada palabra y buscamos con AND
                var words = q.split(" ");

                var containsAllWords = true;
                for (var i=0; i<words.length; i++){
                    if( words[i].trim()!=="" ) {
                        var subresult = false;

                        subresult = subresult || cleanText($this.attr("data-modelo")).indexOf(words[i]) >= 0;
                        subresult = subresult || cleanText($this.attr("data-nombre")).indexOf(words[i]) >= 0;
                        subresult = subresult || cleanText($this.attr("data-tejido")).indexOf(words[i]) >= 0;
                        subresult = subresult || cleanText($this.attr("data-color")).indexOf(words[i]) >= 0;
                        subresult = subresult || cleanText($this.attr("data-variante1")).indexOf(words[i]) >= 0;
                        subresult = subresult || cleanText($this.attr("data-variante2")).indexOf(words[i]) >= 0;
                        subresult = subresult || cleanText($this.attr("data-variante3")).indexOf(words[i]) >= 0;

                        if (!subresult) {
                            containsAllWords = false;
                        }
                    }
                }

                if(containsAllWords){
                    $this.show();
                    resultFind++;
                } else {
                    $this.hide();
                }
            });

            if(resultFind>0){
                var totalResult = $(".table-inc-pedido-detalle tbody tr").length;
                result.html(resultFind + " variantes encontradas de " + totalResult);
            }else{
                result.html("No se han encontrado resultados para la búsqueda");
            }

        }else{
            result.html("Mostrando todas las variantes");

            $(".table-inc-pedido-detalle tbody tr").show();
        }

        //Mostramos solo los titulos de las variantes que no se encuentren al filtrar

        $(".table-inc-pedido-detalle thead").each(function() {
            var $this = $(this);
            if($this.next("tbody").find("tr:visible").length===0) {
                $this.find("tr:nth-child(2)").hide();
            }else{
                $this.find("tr:nth-child(2)").show();
            }
        });

        //if q tiene valor
        //recorret todos los tr y comparar q con los data (como en el paso 2)
        //si encontramos algo -> mostramos el tr
        //si no -> ocultamos
        //si q es vacio
        //mostramos todos

        //como tratamos varias palabras
        //Que hacemos con los thead si su tbody hermano/siguiente tiene todas las tr ocultas
    }
    //Lanzar  la funcion cuando pulses enter en el input

    $(".form-group-search button").click(function(){
        search();
    });

    $(".form-group-search input").keypress(function(event){
        if (event.keyCode === 13) {
            search();
        }
    });

    $(".table-inc-pedido-detalle thead h5").click(function(){
        $(this).find(".fa").toggleClass("fa-minus-circle").toggleClass("fa-plus-circle");
        var $thead = $(this).closest("thead");
        $thead.toggleClass("closed");
        $thead.find("tr:nth-child(2)").toggle();
        $thead.next("tbody").toggle();
    });


});
